import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "./firebase";
import { FaCheck, FaExclamation } from "react-icons/fa";
import { sendEmailVerification, signOut } from "firebase/auth";
import "tailwindcss/tailwind.css";

function VerifyEmail() {
  const [verificationError, setVerificationError] = useState(null);
  const [isVerificationSuccess, setIsVerificationSuccess] = useState(false);
  const [storedEmail, setStoredEmail] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (user && !user.emailVerified) {
        try {
          await sendEmailVerification(user);
        } catch (error) {
          console.error("Error sending email verification:", error.message);
          setVerificationError(
            "Error sending email verification. Please try again."
          );
        }
      } else {
        navigate("/");
      }
    });

    return () => {
      unsubscribe();
    };
  }, []);

  const handleResendVerification = async () => {
    try {
      const user = auth.currentUser;

      if (user && user.email) {
        await sendEmailVerification(user);
        setIsVerificationSuccess(true);
        setVerificationError(null);
        navigate("/login");
      } else if (storedEmail) {
        await auth.sendEmailVerification(auth, storedEmail);
        setIsVerificationSuccess(true);
        setVerificationError(null);
      } else {
        setVerificationError("User not found");
      }
    } catch (error) {
      console.error("Error resending email verification:", error.message);
      setVerificationError(
        "Error resending email verification. Please try again."
      );
    }
  };

  const handleHome = () => {
    signOut(auth);
    navigate("/login");
  };

  return (
    <div className="flex items-center justify-center h-screen">
      <div className="w-full max-w-md p-8 bg-white rounded-md shadow-md">
        <h2 className="text-2xl font-bold mb-4">Email Verification</h2>
        {isVerificationSuccess ? (
          <div className="flex items-center text-green-500">
            <FaCheck className="mr-2" />
            <p>Email verification sent. Please check your email.</p>
          </div>
        ) : (
          <>
            <p className="mb-4">
              An email verification link has been sent to your email address.
            </p>
            <p className="mb-4">
              Please check your email and click the verification link to
              activate your account.
            </p>
            {verificationError && (
              <div className="flex items-center text-red-500 mb-4">
                <FaExclamation className="mr-2" />
                <p>{verificationError}</p>
              </div>
            )}
          </>
        )}
        <button
          onClick={() => {
            setStoredEmail(auth.currentUser?.email);
            handleResendVerification();
          }}
          className="w-full bg-[#9999ff] text-white p-2 rounded-md hover:bg-[#ff8080] transition duration-300"
        >
          Resend Verification Email
        </button>
        <button
          onClick={() => {
            handleHome();
          }}
          className="w-full bg-[#9999ff] text-white mt-4 mb-4 p-2 rounded-md hover:bg-[#ff8080] transition duration-300"
        >
          Go back to Login
        </button>
        ;
      </div>
    </div>
  );
}

export default VerifyEmail;
